import { useLang } from "@/i18n";

const Marquee = () => {
  const { t, lang } = useLang();
  const items = [...t.marquee, ...t.marquee];

  return (
    <div
      data-testid="marquee-strip"
      className="overflow-hidden border-y border-black/10 bg-travertine py-5"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {items.map((item, i) => (
          <span key={`${lang}-${i}`} className="flex items-center gap-10">
            <span className="font-display text-2xl italic text-charcoal/70 lg:text-3xl">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-terracotta" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
